import Form from '../../form';
import Model from '../../../model/model';

import i18n from '../../../i18n';

import { pst } from '../../../http/api';
import { ask } from '../../../utils/popups';





let ifn; i18n.then( i => ifn = i );

export default Form.extend( {

    template: 'jst/auth.code.form',

    events: {

        'keydown [type=text]'(e) {
            if (e.key.length > 1)
                if (!['Tab', 'ArrowLeft', 'ArrowRight', 'Escape', 'Delete', 'Backspace'].includes( e.key ))
                    return;

            switch (e.key) {
                case '0': case '1': case '2': case '3': case '4': case '5': case '6': case '7': case '8': case '9':
                    this.val( e.key );
                case 'Tab': 
                case 'ArrowRight': 
                    this.next(); break;

                case 'ArrowLeft':
                    this.prev(); break;
                case 'Escape':
                    this.$el.closest( '.modal' ).find( '.action-reject' ).click(); break;
                case 'Delete': 
                    this.val( '' ); break;
                case 'Backspace':
                    if (this.val().length === 0)
                        this.prev();
                    else
                        this.val( '' );
            }

            return e.preventDefault(), false;
        },

        'focus [type=text]'({ currentTarget }) {
            currentTarget.select();
        }

    },

    serialize() {
        const { email, next_attempt_at } = this.options;
        return {
            email,
            next_attempt_at,
            secondsLeft: Math.max( 0, next_attempt_at - new Date() / 1000 ) | 0
        }
    },

    next() {
        const { tabIndex } = this.$( ':focus' )[0];
        return this.pick( +tabIndex < 6 ? +tabIndex + 1 : 1 );
    },

    prev() {
        const { tabIndex } = this.$( ':focus' )[0];
        return this.pick( +tabIndex > 1 ? +tabIndex - 1 : 6 );
    },

    val(value) {
        const $input = this.$( ':focus' );
        if (value === undefined)
            return $input.val();
        else
            return $input.val( value ), this.updateSendButton();
    },

    pick(tabIndex) {
        this.$( `[type=text][tabindex=${tabIndex}]` ).focus();
    },

    code() {
        return 'abcdef'.split( '' )
            .map( name => this.$( `[name="${name}"]`).val() )
            .join( '' );
    },

    updateSendButton() {
        this.$el.closest( '.modal' ).find( '.action-accept' )
            [0]
            .disabled = this.code().length < 6;
    },

    updateNewCodeButton() {
        const { next_attempt_at } = this.options;

        const secondsLeft = Math.max( 0, next_attempt_at - new Date() / 1000 ) | 0;
        if (secondsLeft > 0) {
            this.$( 'button' ).find( 'span' ).css( 'display', 'inline' ).text( `(${secondsLeft})` );
            this.$( 'button' ).prop( 'disabled', true );
        } else {
            this.$( 'button' ).find( 'span' ).css( 'display', 'none' );
            this.$( 'button' ).prop( 'disabled', false );
        }
    },

}, {

    popup( { token, next_attempt_at, email, send, newCode }) {
        const Class = this;
        const form = new Class( {

            token, next_attempt_at,  email,

            [Form.event( 'code:get-new')]: () => newCode( form )
                .then( () => {
                    form.$( '.code-message-container' ).html( 
                        `<p class="alert alert-info --fade-in" style="height:34px;line-height:34px;padding:0 15px;">${ifn( 'auth::new code sent' )}</p>` );
                    setTimeout( 
                        () => form.$( '.code-message-container p' ).removeClass( '--fade-in' ).addClass( '--fade-out' ), 
                        5000 );
                } )
                .catch( resp => Form.handleHttpError( form, resp ) ),

        } );
        const binding = form.bind( new Model( { 
            a: '', b: '', c: '', d: '', e: '', f: '',
        } ) );
    
        binding.then( form => {
            setInterval( () => form.updateNewCodeButton(), 500 );
        } );
    
        return ask( binding,
            'auth::confirmation', 'actions::confirm', 'actions::cancel', 
            {
                afterRender(_, firstTime) {
                    if (firstTime)
                        this.$( '.action-accept' )[0].disabled = true;
                }
            },
            form => send( form.code(), form ) );
    },

} );


// WEBPACK FOOTER //
// ./src/js/view/module/auth/code.form.js